var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var EllipseData = require('../../../svg/ellipseData.js');
var PathData = require('../../../svg/pathData.js');
var PathObjectData = require('../../../svg/pathObjectData.js');
var PathType = require('../../../svg/pathType.js');
var IPCRules = require('../ipcRules');
var ComponentAttribute = require('./componentAttribute.js');
var DualRowPackageData = require('./dualRowPackageData.js');

var MoldedBodyData = function(position, angle, init) {
    DualRowPackageData.apply(this, arguments);

    this.oddPadWidthMax = this.value("oddPadWidthMax", true);
    this.oddPadWidthMin = this.value("oddPadWidthMin", true);
    this.oddPadHeightMax = this.value("oddPadHeightMax", true);
    this.oddPadHeightMin = this.value("oddPadHeightMin", true);

    //component family if any
    this.componentFamily = this.value("componentFamily", true);

    this.nonTransformedSegmentedGeometry.addTrigger(this.oddPadWidthMax);
    this.nonTransformedSegmentedGeometry.addTrigger(this.oddPadWidthMin);
    this.nonTransformedSegmentedGeometry.addTrigger(this.oddPadHeightMax);
    this.nonTransformedSegmentedGeometry.addTrigger(this.oddPadHeightMin);
    this.nonTransformedSegmentedGeometry.addTrigger(this.componentFamily);
 
};

lib_core.inherit(MoldedBodyData, DualRowPackageData);
lib_core.JsonParser.registerClass(MoldedBodyData, "MoldedBodyData");

module.exports = MoldedBodyData;

MoldedBodyData.prototype.setupMinMaxPtrMap = function() {
    DualRowPackageData.prototype.setupMinMaxPtrMap.call(this);
    this.minMaxPointerMap["oddPadHeight"] = [this.oddPadHeightMin, this.oddPadHeightMax];
    this.minMaxPointerMap["oddPadWidth"] = [this.oddPadWidthMin, this.oddPadWidthMax];
    this.validationMap["oddPadHeightMax"] = [this.oddPadHeightMax];
    this.validationMap["oddPadWidthMax"] = [this.oddPadWidthMax];  
};

/**
 * Calculate pads geometry
 * @param  {boolean} absolutePositions
 * @return {array} Array of pads.
 */
MoldedBodyData.prototype.getPads = function(absolutePositions) {
    var self = this;
    var pads = [];

    //reset component
    self.component.reset();
    self.updateComponentCalculator(self.horizontalLeadToLeadSpanMin(), self.horizontalLeadToLeadSpanMax());

    var motif = self.getMotif(),
        hPitch = self.component.C;

    //left pad
    var pad = motif.clone();
    var leftPadWidth = motif.getTopCopper().width();
    pad.move(new lib_geometry.Coord(-0.5 * hPitch, 0));
    pads.push(pad);

    //calculate right pad
    //both pads width are same if oddPadWidthMax is undefined or 0
    if (self.oddPadWidthMax()) {
        //right pad's either padWidthMin or padWidthMax is not same as that of left pad update pad size for right pad with new padWidthMin and padWidthMax
        if (self.oddPadWidthMax() !== self.padWidthMax() || self.oddPadWidthMin() !== self.padWidthMin()) {
            //update component with new padWidthMin and padWidthMax
            self.component.padWidthMax = self.oddPadWidthMax();
            self.component.padWidthMin = self.oddPadWidthMin();

            self.updateComponentCalculator();
            motif = self.getMotif();
        }
    }

    if (self.oddPadHeightMax()) {
        if (self.oddPadHeightMax() !== self.padHeightMax() || self.oddPadHeightMin() !== self.padHeightMin()) {
            self.component.padHeightMax = self.oddPadHeightMax();
            self.component.padHeightMin = self.oddPadHeightMin();

            self.updateComponentCalculator();
            motif = self.getMotif();
        }
    }

    //right pad
    pad = motif.clone();
    var rightPadWidth = motif.getTopCopper().width();
    var offset = hPitch / 2 - rightPadWidth / 2 + leftPadWidth / 2;

    pad.move(new lib_geometry.Coord(offset, 0));
    pads.push(pad);

    self.updatePads(pads, absolutePositions);
    return pads;
};

MoldedBodyData.prototype.getSilkscreen = function(pads) {
    var self = this;
    var silkscreen = [];

    //no silkscreen if there are no pads
    if(pads.length === 0) return silkscreen;

    var body = self.getBodyForSilkscreen(),
        leftPad = pads[0],
        topLineY = leftPad.getPos().y + leftPad.getTopCopper().height() / 2 + IPCRules.silkscreenClearance + IPCRules.silkscreenStrokeWidth / 2,
        bottomLineY = leftPad.getPos().y - leftPad.getTopCopper().height() / 2 - IPCRules.silkscreenClearance - IPCRules.silkscreenStrokeWidth / 2;

    if(self.componentFamily() === ComponentAttribute.moldedBodyComponentFamily["POLARIZED_CAPACITOR"] ||
        self.componentFamily() === ComponentAttribute.moldedBodyComponentFamily["POLARIZED_DIODE"] ||
        self.componentFamily() === ComponentAttribute.moldedBodyComponentFamily["LED"]) {

        ////////////////////////////////////////////////////
        //   Component Silkscreen for polarized component //
        ////////////////////////////////////////////////////

        var lineStartX = leftPad.getPos().x - leftPad.getTopCopper().width() / 2 - IPCRules.silkscreenClearance - IPCRules.silkscreenStrokeWidth / 2;
        var pathData;

        if (leftPad.getPos().y + leftPad.getTopCopper().height() / 2 + IPCRules.silkscreenClearance + IPCRules.silkscreenStrokeWidth / 2 > body.height / 2) {
            pathData = new PathData(new lib_geometry.Coord(body.width / 2, topLineY), IPCRules.silkscreenStrokeWidth);
            pathData.addObject(new PathObjectData(new lib_geometry.Coord(lineStartX, topLineY), PathType.LINE));
            pathData.addObject(new PathObjectData(new lib_geometry.Coord(lineStartX, bottomLineY), PathType.LINE));
            pathData.addObject(new PathObjectData(new lib_geometry.Coord(body.width / 2, bottomLineY), PathType.LINE));
        } else {
            pathData = new PathData(new lib_geometry.Coord(body.width / 2, body.height / 2), IPCRules.silkscreenStrokeWidth);
            pathData.addObject(new PathObjectData(new lib_geometry.Coord(lineStartX, body.height / 2), PathType.LINE));
            pathData.addObject(new PathObjectData(new lib_geometry.Coord(lineStartX, -body.height / 2), PathType.LINE));
            pathData.addObject(new PathObjectData(new lib_geometry.Coord(body.width / 2, -body.height / 2), PathType.LINE));
        }

        silkscreen.push(pathData);
    } else {
        /////////////////////////////////////////////////////////
        //   Component Silkscreen for non-polarized component  //
        /////////////////////////////////////////////////////////
        //TODO: update silkscreen if right pad is higher than top edge
        if (leftPad.getPos().y + leftPad.getTopCopper().height() / 2 + IPCRules.silkscreenClearance + IPCRules.silkscreenStrokeWidth / 2 > body.height / 2) {
            pathData = new PathData(new lib_geometry.Coord(-body.width / 2, topLineY), IPCRules.silkscreenStrokeWidth);
            pathData.addObject(new PathObjectData(new lib_geometry.Coord(body.width / 2, topLineY), PathType.LINE));
            silkscreen.push(pathData);

            pathData = new PathData(new lib_geometry.Coord(-body.width / 2, bottomLineY), IPCRules.silkscreenStrokeWidth);
            pathData.addObject(new PathObjectData(new lib_geometry.Coord(body.width / 2, bottomLineY), PathType.LINE));
            silkscreen.push(pathData);
        } else {
            pathData = new PathData(new lib_geometry.Coord(-body.width / 2, body.height / 2), IPCRules.silkscreenStrokeWidth);
            pathData.addObject(new PathObjectData(new lib_geometry.Coord(body.width / 2, body.height / 2), PathType.LINE));
            silkscreen.push(pathData);

            pathData = new PathData(new lib_geometry.Coord(-body.width / 2, -body.height / 2), IPCRules.silkscreenStrokeWidth);
            pathData.addObject(new PathObjectData(new lib_geometry.Coord(body.width / 2, -body.height / 2), PathType.LINE));
            silkscreen.push(pathData);
        }
    }

    return silkscreen;
};


